import { Injectable } from '@angular/core';
import { AppState } from '../app.state';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CookieStorageService {

  constructor(
    private appState: AppState, 
    private cookieService: CookieService,
  ) { }

  setCookie(name: string, value: string) {
    let cookieDomain = this.appState.companyInfoValue?.cookieDomain;
    this.cookieService.set(name, value, {
      domain: '.' + cookieDomain,
      sameSite: 'Lax',
    });
  }


  clearAllCookies() {
    let cookieDomain = this.appState.companyInfoValue?.cookieDomain;

    this.cookieService.delete("idToken", '/', '.' + cookieDomain);
    this.cookieService.delete("refreshToken", '/', '.' + cookieDomain);
    this.cookieService.delete("accessToken", '/', '.' + cookieDomain);
  }
}

